module.exports = __webpack_public_path__ + "static/media/jsFramework.c0ad0900.svg";